import React, { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';

const DemandRow = React.memo(({ demand, dates, vendorId }) => {
	const navigate = useNavigate();

	const totalDemandEvents = useMemo(() => {
		return dates.reduce((sum, date) => {
			const dayDemand = demand.find((d) => d.date === date);
			return sum + (dayDemand?.totalEvents || 0);
		}, 0);
	}, [demand, dates]);

	const handleEventClick = useCallback((e) => {
		if (e.workspaceId && e.projectId && e.eventId) {
			navigate(`/${vendorId}/shoots/${e.workspaceId}/${e.projectId}/${e.eventId}`);
		}
	}, [vendorId, navigate]);

	const formatEvent = (e) => (
		<>
			{e.workspaceId && <span>{e.workspaceId} - </span>}
			{e.projectTitle && <span>{e.projectTitle} - </span>}
			<strong>{e.eventName || 'Untitled'}</strong>
			{e.city && <span>, {e.city}</span>}
		</>
	);

	return (
		<div className="crew-planner-row demand-row">
			<div className="crew-planner-name-col">
				<span>Demand</span>
			</div>
			{dates.map((date) => {
				const dayDemand = demand.find((d) => d.date === date);
				const demandEvents = dayDemand?.events || [];
				const needCrewEvents = demandEvents.filter((e) => e.needsCrew);
				const assignedEvents = demandEvents.filter((e) => !e.needsCrew);

				const tooltipContent =
					demandEvents.length > 0 ? (
						<div className="demand-tooltip">
							{needCrewEvents.length > 0 && (
								<div className="demand-tooltip-section">
									<div className="demand-tooltip-section-title need-crew">
										Need Crew ({needCrewEvents.length})
									</div>
									{needCrewEvents.map((e, i) => (
										<div key={i} className="demand-tooltip-item need clickable" onClick={() => handleEventClick(e)}>
											<span className="demand-tooltip-dot need" />
											<span className="demand-tooltip-label">{formatEvent(e)}</span>
											<span className="demand-tooltip-count need">
												{e.assignedCount}/{e.requiredCount}
											</span>
										</div>
									))}
								</div>
							)}
							{assignedEvents.length > 0 && (
								<div className="demand-tooltip-section">
									<div className="demand-tooltip-section-title assigned">
										Assigned ({assignedEvents.length})
									</div>
									{assignedEvents.map((e, i) => (
										<div key={i} className="demand-tooltip-item clickable" onClick={() => handleEventClick(e)}>
											<span className="demand-tooltip-dot assigned" />
											<span className="demand-tooltip-label">{formatEvent(e)}</span>
											<span className="demand-tooltip-count assigned">
												{e.assignedCount}/{e.requiredCount}
											</span>
										</div>
									))}
								</div>
							)}
						</div>
					) : null;

				return (
					<div
						key={date}
						className={`crew-planner-date-col demand-cell ${dayDemand?.needCrew > 0 ? 'has-need' : ''}`}
					>
						<Tooltip title={tooltipContent} placement="bottom" overlayClassName="demand-tooltip-overlay" overlayStyle={{ maxWidth: 380 }}>
							<div className="demand-cell-inner">
								<div className="demand-events">
									{dayDemand?.totalEvents || 0} events
								</div>
								{dayDemand?.needCrew > 0 && (
									<div className="demand-need">
										{dayDemand.needCrew} need crew
									</div>
								)}
							</div>
						</Tooltip>
					</div>
				);
			})}
			<div className="crew-planner-total-col demand-total">
				<span>{totalDemandEvents}</span>
			</div>
		</div>
	);
});

export default DemandRow;
